
import Header from "@/components/header/header.vue";
import { ref } from "vue";
import { useRouter,useRoute } from "vue-router";
import { Toast } from "vant";
export default {
  components: {
    Header,
  },
  setup() {
    let router = useRouter();
    let route = useRoute()
  
    let searchKeyword = ref(route.query.keywords ? route.query.keywords : '');
    //搜索跳转
    const onSearchValue = (value: string) => {
      if (value) {
        router.push({
          path: "/shop-list",
          query: {
            keywords: value.trim(),
            id:route.query.id
          },
        });
      } else {
        Toast("Please enter a keyword");
      }
    };
    return {
      onSearchValue,
      searchKeyword,
    };
  },
};
